import React from "react";
import styled from "styled-components";
import MoonIcon from "../assets/images/icon-moon.svg";
import SunIcon from "../assets/images/icon-sun.svg";

const Container = styled.div`
  width: 45%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 600px) {
    width: 90%;
  }
`;

const Title = styled.h1`
  letter-spacing: 5px;
  color: white;
`;

const ThemeToggleIcon = styled.img`
  cursor: pointer;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const Header = ({ isThemeDark, setIsThemeDark }) => {
  return (
    <Container>
      <Title>TODO</Title>
      <ThemeToggleIcon
        src={isThemeDark ? SunIcon : MoonIcon}
        alt="theme"
        onClick={() => setIsThemeDark((prev) => !prev)}
      />
    </Container>
  );
};

export default Header;
